import AuthViewContainer from "modules/auth/layout/AuthViewContainer";
import AuthViewContent from "modules/auth/layout/AuthViewContent";
import { AuthTopBlock } from "modules/auth/layout/AuthTopBlock";
import { useI18n } from "i18n";
import UsernamePasswordSignInForm from "modules/auth/signIn/UsernamePasswordSignInForm";
import { PAGES, usePageTracking } from "modules/tracking";

const SignInForm = () => {
  const { t } = useI18n("auth");

  usePageTracking(PAGES.TEMPORARY_SIGNIN);

  return (
    <AuthViewContainer>
      <AuthViewContent>
        <AuthTopBlock
          subtitle={t("auth:formerly.remo")}
          text={t("auth:temporary.sign.in.description")}
        />

        <div className="email-container">
          <UsernamePasswordSignInForm prefilledEmail="" disableForgotPassword />
        </div>
      </AuthViewContent>
    </AuthViewContainer>
  );
};

export default SignInForm;
